import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import DocumentError from "../../models/document-error";

interface DocumentErrorDeleteModalProps {
  show: boolean;
  documentError?: DocumentError;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentErrorDeleteModal: React.FC<DocumentErrorDeleteModalProps> = ({
  show,
  documentError,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = documentError
    ? `Está seguro de que quiere eliminar el error conocido de documento #${documentError.id}`
    : "";

  const onDeleteClick = async () => {
    if (documentError !== undefined) {
      setSubmitting(true);
      const documentErrorStatus = await deleteItem<DocumentError>(
        `/document_errors/${documentError.id}/`,
        documentError
      );

      if (documentErrorStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (documentErrorStatus.detail !== undefined) {
          message = documentErrorStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DocumentErrorDeleteModal;
